module.exports = __webpack_public_path__ + "static/media/basic_docs.f59dc226.md";


//////////////////
// WEBPACK FOOTER
// ./src/examples/basic/basic_docs.md
// module id = 745
// module chunks = 0